import { render, staticRenderFns } from "./AsMenu.vue?vue&type=template&id=e6f0d460&"
import script from "./AsMenu.vue?vue&type=script&lang=js&"
export * from "./AsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AsMenu.vue?vue&type=style&index=0&id=e6f0d460&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports